import { Space } from 'antd';
import styled from 'styled-components';

import { TYPE_CUSTOM_FIELD } from 'screens/ProductDetails/common/constants/previousDaySummaryTable';

export const GroupingGridWrapper = styled('div')`
  [col-id='${TYPE_CUSTOM_FIELD}'] {
    font-size: calc(var(--ag-font-size));
  }

  .ag-header-cell,
  .ag-header-group-cell {
    padding-left: 10px;
    padding-right: 10px;
  }

  .groupingTypeCellContent,
  .parentTypeCellContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .groupingTypeCellContent,
  .parentTypeCellContent {
    font-weight: bold;
  }

  .childTypeCellContent {
    padding-left: 20px;
    text-align: left;
  }

  .parentRowCell {
    font-weight: bold;
  }

  .childRowCell {
    font-weight: normal;
  }
`;

/**
 * Marker set beside the label. The label stays « Size grid », since that is indeed the grid in
 * use; the marker only says where it comes from.
 */
export const AutoGridMark = styled.span`
  margin-left: 8px;
  padding: 0 6px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: ${(p) => p.theme.dark_gray};
  background: ${(p) => p.theme.primary_yellow};
  border-radius: 8px;
`;

export const StyledSpace = styled(Space)`
  width: 100%;
`;
